// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__HciLF","spinner__small":"styles_spinner__small__ntP9H","fon":"styles_fon__h0Zuq"};